module.exports = __webpack_public_path__ + "img/litnisschrofen.6e7bdc20.jpg";